var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcomLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Ecom logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ecom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.5h9v6a1.5 1.5 0 01-1.5 1.5h-6A1.5 1.5 0 017.5 15.5v-6z",
    fill: "#fff",
    opacity: 0.95
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 11.5h5v1h-3v1h2v1h-2.5v1h-1v-4z",
    fill: "currentColor",
    transform: "translate(0,0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcomLogo);
export default __webpack_public_path__ + "static/media/ecom-logo.99361afd98fe0db7f1bf55ee6acd04b6.svg";
export { ForwardRef as ReactComponent };